import { useState } from "react"
import Stack from "@mui/material/Stack"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined"
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined"
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined"
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined"
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';

function ComprobanteActions({ comprobante, onAction }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const menuOpen = Boolean(anchorEl)
  const isAnulado = comprobante.id_estado === 260;

  const openMenu = (event) => setAnchorEl(event.currentTarget)
  const closeMenu = () => setAnchorEl(null)

  const run = (action) => {
    closeMenu()
    onAction(action, comprobante)
  }

  const primaryActions = [
    { key: "view-pdf", label: "Ver PDF", icon: <VisibilityOutlinedIcon fontSize="small" />, color:"primary"},
    { key: "detail", label: "Ver detalle", icon: <InfoOutlinedIcon fontSize="small" /> , color:"primary"},
    { key: "anular-comprobante", label: "Anular Comprobante", icon: <DoDisturbOnIcon fontSize="small" />, color:"warning", disabled:!comprobante.anulable || isAnulado }      
  ]

  return (
    <Stack direction="row" spacing={0.25} alignItems="center">
      {primaryActions.map((action) => (
        <Tooltip key={action.key} title={action.label}>
          <IconButton 
            size="small" 
            color={action.color} 
            onClick={() => run(action.key)} 
            aria-label={action.label} 
            disabled={action.disabled}
          >
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Stack>
  )
}

export default ComprobanteActions
